import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'lib/auth';
import { rememberReturnTo } from 'lib/returnTo';
import { paths } from 'routes';

export const MoreOptionsButton = ({ adId, disabled }) => {
  const { t } = useTranslation();
  const { account } = useAuth();
  const target = paths.jobAdsDetailsView(adId);

  return (
    <Button
      size="medium"
      variant="contained"
      color="primary"
      sx={{ mb: 0.5, width: 1, maxWidth: 300, alignSelf: "center"}}
      href={account ? target : paths.auth.login}
      onClick={() => !account && rememberReturnTo(target)}
      target={"_top"}
      rel={"noopener noreferrer"}
      disabled={disabled}
    >
      {t(account ? 'website:jobDetails.moreOptions' : 'website:jobDetails.loginForMoreOptions')}
    </Button>
  );
};
